<div class="flex h-full flex-1 flex-col place-content-center items-stretch justify-between">
  <h2 class="layout-login-regular-title login-select-authentication--title">{{ 'LOGIN.TITLE.LOGIN' | translate }}</h2>

  @if (ssoDisabled()) {
    <section class="btn-container flex flex-col items-stretch justify-center">
      <button mat-button type="button" data-cy="login-select-authentication-classic-authentication-button" (click)="signInWithEmailPassword.emit()" class="">
        {{ 'LOGIN.LOGIN_WITH_EMAIL_PASSWORD' | translate }}
      </button>
    </section>
  } @else {
    <section class="flex flex-1 flex-col items-stretch justify-center gap-4">
      <div class="btn-container flex flex-col items-stretch justify-center">
        <button
          mat-raised-button
          type="button"
          data-cy="login-select-authentication-sso-authentication-button"
          (click)="signInWithSSO.emit()"
          class="sso-action"
        >
          <mat-icon [svgIcon]="'air_liquide_logo'" />&nbsp;{{ 'LOGIN.SSO_CONNECT' | translate }}
        </button>
      </div>
      <div class="btn-container flex flex-col items-stretch justify-center">
        <button
          mat-button
          type="button"
          data-cy="login-select-authentication-email-password-button"
          (click)="signInWithEmailPassword.emit()"
          class="email-password-action"
        >
          {{ 'LOGIN.LOGIN_WITH_EMAIL_PASSWORD' | translate }}
        </button>
      </div>
    </section>
  }

  @if (carmUrl()) {
    <div class="login-select-authentication--no-account-message flex items-center justify-start">
      <span>{{ 'LOGIN.NO_ACCOUNT' | translate }}</span>
      <a class="flex items-center justify-start" [href]="carmUrl()" target="_blank" data-cy="login-select-authentication-request-account-link"
        >&nbsp;{{ 'LOGIN.REQUEST_ACCOUNT' | translate }}&nbsp;<mat-icon>open_in_new</mat-icon>
      </a>
    </div>
  }
</div>
